(function () {
  const CART_SECTION_ID = 'static-cart';

  function getSectionIds() {
    const bars = document.querySelectorAll('[data-free-shipping-section-id]');
    const ids = bars.length
      ? Array.from(
          new Set(
            Array.from(bars)
              .map((el) => el.getAttribute('data-free-shipping-section-id'))
              .filter(Boolean)
          )
        )
      : [];
    if (ids.indexOf(CART_SECTION_ID) === -1) {
      ids.push(CART_SECTION_ID);
    }
    const path = (window.location.pathname || '').replace(/\/$/, '');
    if ((path === '/cart' || path.endsWith('/cart')) && ids.indexOf('main') === -1) {
      ids.push('main');
    }
    return ids;
  }

  function refreshFreeShippingBars() {
    const sectionIds = getSectionIds();
    if (!sectionIds.length) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sections', sectionIds.join(','));
    url.searchParams.set('_', Date.now());

    fetch(url.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then((res) => res.json())
      .then((data) => {
        var cartBar = null;
        sectionIds.forEach((id) => {
          const html = data[id];
          if (!html) return;

          const wrapper = document.createElement('div');
          wrapper.innerHTML = html;

          const freshBar = wrapper.querySelector(
            '[data-free-shipping-section-id="' + id + '"]'
          );
          if (!freshBar) return;

          if (id === CART_SECTION_ID || id === 'main') {
            cartBar = freshBar;
            return;
          }

          document
            .querySelectorAll('[data-free-shipping-section-id="' + id + '"]')
            .forEach((oldBar) => {
              oldBar.replaceWith(freshBar.cloneNode(true));
            });
        });

        if (cartBar) {
          document
            .querySelectorAll('[data-free-shipping-bar]')
            .forEach((oldBar) => {
              oldBar.replaceWith(cartBar.cloneNode(true));
            });
        } else {
          sectionIds.forEach((id) => {
            const html = data[id];
            if (!html) return;
            const wrapper = document.createElement('div');
            wrapper.innerHTML = html;
            const freshBar = wrapper.querySelector(
              '[data-free-shipping-section-id="' + id + '"]'
            );
            if (!freshBar) return;
            document
              .querySelectorAll('[data-free-shipping-section-id="' + id + '"]')
              .forEach((oldBar) => {
                oldBar.replaceWith(freshBar.cloneNode(true));
              });
          });
        }
      })
      .catch((err) => {
        console.error('Free shipping bar refresh failed', err);
      });
  }

  // debounce so multiple clicks don’t spam
  let refreshTimer = null;
  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshFreeShippingBars, 700);
  }

  // Any “Add to cart” click
  document.addEventListener('click', function (event) {
    const addToCartTrigger = event.target.closest(
      [
        'form[action*="/cart/add"] [type="submit"]',
        'button[name="add"]',
        'button[name="add-to-cart"]',
        'button[data-add-to-cart]',
        '.product-form__submit',
        '.product-form--atc',
        '.btn-add-to-cart',
        '.add-to-cart'
      ].join(',')
    );

    if (addToCartTrigger) {
      scheduleRefresh();
    }

    // Quantity +/- buttons in cart/mini-cart/overlay
    const qtyTrigger = event.target.closest(
      [
        '.cart__quantity-button',
        '.cart-quantity-button',
        '.qty-button',
        '[data-quantity-plus]',
        '[data-quantity-minus]',
        '[data-quantity-adjust]'
      ].join(',')
    );

    if (qtyTrigger) {
      scheduleRefresh();
    }
  });

  // Quantity inputs changed manually
  document.addEventListener('change', function (event) {
    if (
      event.target.matches(
        [
          'input[name="quantity"]',
          'input[name="updates[]"]',
          '.cart-quantity-input',
          '[data-quantity-input]'
        ].join(',')
      )
    ) {
      scheduleRefresh();
    }
  });

  // If theme fires its own cart event, we piggyback
  document.addEventListener('cart:updated', scheduleRefresh);

  // On cart page load, refresh once so the bar matches current subtotal (recovers from ATC/quantity glitches)
  function isCartPage() {
    var path = (window.location.pathname || '').replace(/\/$/, '');
    return path === '/cart' || path.endsWith('/cart');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      if (isCartPage()) {
        setTimeout(refreshFreeShippingBars, 350);
      }
    });
  } else if (isCartPage()) {
    setTimeout(refreshFreeShippingBars, 350);
  }
})();